import React, {useEffect} from 'react';
import Aos from "aos";
import 'aos/dist/aos.css';

export default function CardSolution(props) {
  const { title, description, icon } = props;
  useEffect(()=> {
    Aos.init();
  },[])

  const descriptionItems = description.split('\n').filter(item => item.trim() !== '');

  return (
    <div className="solution-card-container" data-aos="fade-up">
       <div className='card-header'>
          <div className='icon'>
            <span className='blob'>
              <i class={icon}></i>
            </span>
          </div>
          <span className='title'><h1>{title}</h1></span>
       </div>
       <div className='card-body'>
       {descriptionItems.map((item, index) => (
            <p key={index}>{item}</p>
        ))}
       </div>
        </div>
  );
}
